<template>
  <div :class="{form__row: row}">
    <ValidationProvider tag="div" class="form__text-field" :rules="rules" v-slot="{ errors }">
      <label :for="id">{{ label }}</label>
      <textarea
          :class="{invalid: errors.length != 0}"
          :id="id"
          cols="30"
          rows="10"
          :value="value"
          @input="handleInput"
      ></textarea>
      <span class="error" v-if="rules != null">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: 'custom-textarea',
  props: {
    row: {
      type: Boolean,
      default: false
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    rules: String
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>

</style>
